import Resolver from './Resolver'

export default Resolver
// eslint-disable-next-line import/export
export * from './Resolver'
